var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.centerDialogVisible,"width":"200px","center":"","show-close":false,"close-on-click-modal":false,"close-on-press-escape":false,"append-to-body":"","modal-append-to-body":"","destroy-on-close":"","lock-scroll":true},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('div',{staticClass:"loadingDialog"},[_c('lottie-layout',{attrs:{"width":138,"height":138,"options":{
    loop: true,
    autoplay:true,
    animationData: 'https://tourimage.huayitraveltd.com/appResource/lottie/blue-loading.json'
  },"title":_vm.title}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ef70783","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/lottie/loadingDialog.vue
// module id = null
// module chunks = 